import React from 'react';
import styled from 'styled-components'

import { InfoIconCard } from '../../../../ui'
import { media } from '../../../../utils/media';

const IconCardWrapper = styled.div`
  width:100%;
  background-color: ${({ theme, $isMini }) => $isMini && theme.colors.NEU_50};
  /* Grid Fallback */
  display: ${({ $showGrid }) => !$showGrid ? 'flex' : 'grid'};
  flex-wrap: ${({ $showGrid }) => !$showGrid ? 'nowrap' : 'wrap'};
  grid-template-columns: ${({ $showGrid }) => $showGrid ? 'repeat(3, 1fr)' : null};
  grid-gap: ${({ $showGrid, $isMini }) => $showGrid ? !$isMini ? '2rem 6rem' : '1rem 1rem' : null};
  margin: ${({ $isMini }) => $isMini ? '3rem 0 0.5rem 0' : '0 0 0.5rem 0'};
  justify-content: ${({ $isMini }) => !$isMini ? 'center' : 'flex-start'};
  gap: ${({ $showGrid }) => !$showGrid ? '8rem' : null};

  ${media.lessThan('tablet')} {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${({ $isMini }) => !$isMini ? '2rem 5rem' : '2rem 1rem'};
    justify-content: center;
  }

  ${media.lessThan('phablet')} {
    grid-gap: ${({ $isMini }) => !$isMini ? '2rem 4rem' : '2rem 0'};
    flex-wrap: wrap;
  }
`;

const InfoIconSection = ({ items, size, showterms }) => {

  const isMini = size === 'small' || size === 'x-small'

  return (
    <>
      {!!items.length &&
        <IconCardWrapper $showGrid={items.length > 2} $isMini={isMini}>
          {items.map((item, i) =>
            <InfoIconCard iconInfo={item} key={i} size={size} />
          )}
        </IconCardWrapper>
      }
    </>
  );
};

export default InfoIconSection;
